<template>
  <button v-if="isInstallable" @click="installApp" :style="`
  background-color:${colors.AppbarColor || '#eee'};
  color:${!colors.AppbarColor ? '#444BA2' : 'white'}`"
          class="shine-button">
    <v-icon :color="!colors.AppbarColor?'primary':'white'">mdi-download</v-icon>
    ΕΓΚΑΤΑΣΤΑΣΗ ΕΦΑΡΜΟΓΗΣ
  </button>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "InstallButton",
  data() {
    return {
      isInstallable: !Cookies.get('appInstalled'),
      deferredPrompt: null
    };
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'colors'
    ])
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', this.beforeInstallPrompt);
    window.addEventListener('appinstalled', this.onAppInstalled);
  },
  beforeDestroy() {
    window.removeEventListener('beforeinstallprompt', this.beforeInstallPrompt);
    window.removeEventListener('appinstalled', this.onAppInstalled);
  },
  methods: {
    beforeInstallPrompt(e) {
      e.preventDefault();
      this.deferredPrompt = e;
      if (!Cookies.get('appInstalled')) {
        this.isInstallable = true;
      }
    },
    onAppInstalled() {
      this.isInstallable = false;
      Cookies.set('appInstalled', true, { expires: 365 }); // Setting it to expire in 1 year.
    },
    async installApp() {
      console.log("Button clicked"); // Log to see if the method is being triggered

      if (!this.deferredPrompt) {
        console.log("No deferredPrompt available");
        return;
      }

      this.deferredPrompt.prompt();

      const choiceResult = await this.deferredPrompt.userChoice;
      if (choiceResult.outcome === 'accepted') {
        console.log("User accepted the install prompt");
        this.deferredPrompt = null;
      } else {
        console.log("User dismissed the install prompt");
      }
    }

  }
};
</script>

<style scoped>

.shine-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  color: #fff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  outline: none;
  border-radius: 4px;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.02857em;
  transition: all 0.2s ease-in-out;
}

.shine-button:hover {
  animation: shine 1s 0.5s forwards infinite; /* shine effect will start 0.5s after page loads */
}


.shine-button::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -100%;
  width: 50%;
  height: 200%;
  background: rgba(255, 255, 255, 0.4); /* shine color */
  transform: rotate(45deg);
  pointer-events: none; /* so the shine won't block button functionality */
  animation: shine 1s 0.5s forwards; /* shine effect will start 0.5s after page loads */
}

@keyframes shine {
  to {
    left: 200%;
  }
}


</style>

